import { BaseElement } from 'base';
import { bus } from 'bus';
import { SLIDE_CART_TOPIC } from 'slide-cart-topic';

const DEMO_MS = 800;

const wait = duration => new Promise(resolve => setTimeout(resolve, duration));

class DesignGuideSlideCart extends BaseElement {
  onConnect() {
    this.flashTimers = new Map();
    this.cleanup(() => {
      this.flashTimers.forEach(id => clearTimeout(id));
      this.flashTimers.clear();
    });

    this.#whenReady('action-button', () => {
      this.qa('action-button.design-guide__chip-action').forEach(chip =>
        chip.run(() => wait(DEMO_MS))
      );

      this.qa('action-button.design-guide__footer-action').forEach(cta =>
        cta.run(() => wait(DEMO_MS))
      );

      this.qa('action-button.design-guide__panel-trigger').forEach(trigger => {
        const target = trigger.closest('[data-panel-target]')?.dataset
          .panelTarget;
        if (target)
          trigger.run(() => {
            trigger.control?.focus();
            bus.publish(SLIDE_CART_TOPIC, target);
          });
      });
    });

    this.#whenReady('drawer-header', () =>
      this.qa('.design-guide__header-action').forEach(header =>
        header.run(() => this.flash(header))
      )
    );

    this.#whenReady('qty-counter', () =>
      this.qa('.design-guide__card-counter').forEach(counter =>
        counter.run(() => wait(DEMO_MS))
      )
    );

    this.#whenReady('link-button', () =>
      this.qa('link-button.design-guide__card-action').forEach(action =>
        action.run(() => this.flash(action))
      )
    );

    this.#whenReady('discount-field', () =>
      this.qa('discount-field').forEach(field =>
        field.run(({ type }) =>
          wait(DEMO_MS).then(() =>
            type === 'apply' ? { applied: true } : null
          )
        )
      )
    );

    this.#whenReady('upsell-carousel', () =>
      this.qa('upsell-carousel').forEach(carousel => {
        const inDrawer = Boolean(carousel.closest('[data-panel-target]'));
        carousel.run(() =>
          wait(DEMO_MS).then(() => {
            if (inDrawer) throw new Error('demo: quick add failed');
          })
        );
      })
    );

    this.bindMessages();
  }

  #whenReady(tag, bind) {
    customElements.whenDefined(tag).then(() => {
      if (this.isConnected) bind();
    });
  }

  async bindMessages() {
    await customElements.whenDefined('inline-message');
    if (!this.isConnected) return;

    this.qa('inline-message').forEach(message =>
      message.run(() => {
        if (!this.isConnected) return;
        const cell = message.closest('.design-guide__cell');
        if (!cell) return;
        cell.tabIndex = -1;
        cell.focus();
      })
    );
  }

  flash(element) {
    clearTimeout(this.flashTimers.get(element));
    element.setAttribute('data-demo-fired', 'true');
    this.flashTimers.set(
      element,
      setTimeout(() => {
        element.removeAttribute('data-demo-fired');
        this.flashTimers.delete(element);
      }, DEMO_MS)
    );
  }
}

if (!customElements.get('design-guide-slide-cart'))
  customElements.define('design-guide-slide-cart', DesignGuideSlideCart);
